// extracted by mini-css-extract-plugin
export var bodySections = "_cs-8";
export var gray = "_cs-7";
export var green = "_cs-4";
export var iconContainer = "_cs-9";
export var iconWidgetContainer = "_cs-1";
export var phoneIcon = "_cs-2";
export var red = "_cs-5";
export var statusDot = "_cs-3";
export var widgetContainer = "_cs-0";
export var yellow = "_cs-6";